import React, { useContext, useState } from "react";
import { FieldError, FieldErrors, FieldValues } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import { smsSend } from "../../api/api-calls";
import { SectionIndicatorContext } from "../../shared/contexts/SectionIndicatorContext";
import { getPhoneNumberDto } from "../../shared/utils/dto-mapper";
import { useStyles } from "./SendSmsButton.style";
import { SmsSendButtonTitleEnum } from "../../shared/enums/sms-send-button-title.enum";

interface SmsSendProps {
	getFieldState: (name: string) => any;
	getValues: (name: string | string[]) => any;
	errors: FieldErrors<FieldValues>;
	watch: (names: string) => string;
	setError: (name: string, error: FieldError) => void;
	tabValue: number;
	setIsDisabled: (val: boolean) => void;
	sentCallback?: () => void;
}

const SendSmsButton = ({ setError, getValues, watch, tabValue, setIsDisabled, sentCallback }: SmsSendProps) => {
	const [buttonTitle, setButtonTitle] = useState<string>(SmsSendButtonTitleEnum.TITLE_1);
	const { setSectionNumber } = useContext(SectionIndicatorContext);
	const watchedPhoneNumber: string = watch("phoneNumber");
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [timesTriggered, setTimesTriggered] = useState<number>(0);
	const styles = useStyles();

	function isButtonActivated(watchedPhoneNumber: string): boolean {
		return !!watchedPhoneNumber.match(/^\+420\s\d{3}\s\d{3}\s\d{3}$/);
	}

	function handleClick(): void {
		setButtonTitle(SmsSendButtonTitleEnum.TITLE_2);
		const phoneNumber = getValues("phoneNumber");
		const phoneNumberDTO = getPhoneNumberDto(phoneNumber);
		smsSend(
			phoneNumberDTO,
			setError,
			setIsLoading,
			setSectionNumber,
			"sms-send",
			timesTriggered,
			setTimesTriggered,
			setIsDisabled,
			sentCallback
		);
	}

	return (
		<div>
			<LoadingButton
				className={styles.btnSend}
				loading={isLoading}
				variant="outlined"
				type="button"
				disabled={!isButtonActivated(watchedPhoneNumber) || timesTriggered > 1}
				onClick={handleClick}
				tabIndex={tabValue}
			>
				{buttonTitle}
			</LoadingButton>
		</div>
	);
};

export default SendSmsButton;
